import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'spaceEntityId',
                },
                'ent:!space:!campus',
              ],
            },
            'Building',
          ],
          [
            {
              '=': [
                {
                  '@$': 'spaceEntityId',
                },
                'ent:!space:!bldg',
              ],
            },
            'Floor',
          ],
          [
            {
              '=': [
                {
                  '@$': 'spaceEntityId',
                },
                'ent:!space:!floor',
              ],
            },
            'Room',
          ],
          [
            {
              '=': [
                {
                  '@$': 'spaceEntityIdSegment',
                },
                'ent:!space:!campus',
              ],
            },
            'Building',
          ],
          [
            {
              '=': [
                {
                  '@$': 'spaceEntityIdSegment',
                },
                'ent:!space:!bldg',
              ],
            },
            'Floor',
          ],
          [
            {
              '=': [
                {
                  '@$': 'spaceEntityIdSegment',
                },
                'ent:!space:!floor',
              ],
            },
            'Room',
          ],
          'Campus',
        ],
      },
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'space',
                },
              },
              subqueries: {
                space: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'spaceRecordId',
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'organizations',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'dim::!space',
                  subqueries: {
                    space: {
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'organization',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '*': [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '+': {
                                        '@': 'weights',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'allowableWeights',
                                    },
                                  },
                                  {
                                    '+': {
                                      '@': 'weights',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@.': '!sqft',
                          },
                        ],
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            and: [
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgRecordId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgEntityId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '!=': [
                                      {
                                        '@': 'organization',
                                      },
                                      null,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          subqueries: {
                            room: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!space',
                              },
                              target: 'ent:!space:!room',
                            },
                            organization: {
                              ref: {
                                attr: 'attr:ent#!org_space#!entry:!space',
                                inherit: '=',
                              },
                              using: 'room',
                              filter: {
                                '=': [
                                  {
                                    '@.': [
                                      '!org',
                                      {
                                        ref: {
                                          entity: {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                ],
                              },
                              target: 'ent:!org_space:!entry',
                            },
                          },
                        },
                        organization: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                            inherit: '=',
                          },
                          filter: {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                          target: 'ent:!org_space:!entry',
                        },
                        roomOrgSpace: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                          },
                          target: 'ent:!org_space:!entry',
                        },
                        allowableWeights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            and: [
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgRecordId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgEntityId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '!=': [
                                      {
                                        '@': 'organization',
                                      },
                                      null,
                                    ],
                                  },
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'funcIdcCat',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          subqueries: {
                            room: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!space',
                              },
                              target: 'ent:!space:!room',
                            },
                            funcIdcCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                            organization: {
                              ref: {
                                attr: 'attr:ent#!org_space#!entry:!space',
                                inherit: '=',
                              },
                              using: 'room',
                              filter: {
                                '=': [
                                  {
                                    '@.': [
                                      '!org',
                                      {
                                        ref: {
                                          entity: {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                ],
                              },
                              target: 'ent:!org_space:!entry',
                            },
                          },
                        },
                      },
                    },
                    roomSqfts: {
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'organization',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '@.': '!sqft',
                      },
                      subqueries: {
                        organization: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                            inherit: '=',
                          },
                          filter: {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                          target: 'ent:!org_space:!entry',
                        },
                        roomOrgSpace: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                          },
                          target: 'ent:!org_space:!entry',
                        },
                      },
                    },
                    organizations: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!org_space:!entry',
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'spaceRecordId',
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'organizations',
                          },
                          null,
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'dim::!space',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      asf: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'space',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'roomSqfts',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '+': {
                                            '@': 'roomSqfts',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    0,
                                  ],
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '@': 'space',
                                        },
                                      },
                                      {
                                        '+': {
                                          '@': 'roomSqfts',
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'spaceEntityIdSegment',
                              },
                            },
                            'ent:!space:!floor',
                          ],
                        },
                        null,
                      ],
                      {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      segmentId: 'space',
                                      variables: {
                                        if: [
                                          [
                                            {
                                              and: [
                                                {
                                                  '=': [
                                                    {
                                                      '``': {
                                                        '@$': 'piRecordId',
                                                      },
                                                    },
                                                    null,
                                                  ],
                                                },
                                                {
                                                  '=': [
                                                    {
                                                      '``': {
                                                        '@$': 'orgRecordId',
                                                      },
                                                    },
                                                    null,
                                                  ],
                                                },
                                              ],
                                            },
                                            {
                                              '{}': {
                                                spaceRecordId: {
                                                  '@.': '!id',
                                                },
                                                spaceEntityIdSegment: {
                                                  '@_': 'id',
                                                },
                                              },
                                            },
                                          ],
                                          [
                                            {
                                              and: [
                                                {
                                                  not: {
                                                    '=': [
                                                      {
                                                        '``': {
                                                          '@$': 'piRecordId',
                                                        },
                                                      },
                                                      null,
                                                    ],
                                                  },
                                                },
                                                {
                                                  '=': [
                                                    {
                                                      '``': {
                                                        '@$': 'orgRecordId',
                                                      },
                                                    },
                                                    null,
                                                  ],
                                                },
                                              ],
                                            },
                                            {
                                              '{}': {
                                                piRecordId: {
                                                  '``': {
                                                    '@$': 'piRecordId',
                                                  },
                                                },
                                                spaceRecordId: {
                                                  '@.': '!id',
                                                },
                                                spaceEntityIdSegment: {
                                                  '@_': 'id',
                                                },
                                              },
                                            },
                                          ],
                                          [
                                            {
                                              and: [
                                                {
                                                  '=': [
                                                    {
                                                      '``': {
                                                        '@$': 'piRecordId',
                                                      },
                                                    },
                                                    null,
                                                  ],
                                                },
                                                {
                                                  not: {
                                                    '=': [
                                                      {
                                                        '``': {
                                                          '@$': 'orgRecordId',
                                                        },
                                                      },
                                                      null,
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                            {
                                              '{}': {
                                                orgEntityId: {
                                                  '``': {
                                                    '@$': 'orgEntityId',
                                                  },
                                                },
                                                orgRecordId: {
                                                  '``': {
                                                    '@$': 'orgRecordId',
                                                  },
                                                },
                                                spaceRecordId: {
                                                  '@.': '!id',
                                                },
                                                spaceEntityIdSegment: {
                                                  '@_': 'id',
                                                },
                                              },
                                            },
                                          ],
                                          {
                                            '{}': {
                                              spaceRecordId: {
                                                '@.': '!id',
                                              },
                                              spaceEntityIdSegment: {
                                                '@_': 'id',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          spaceEntityId: {
                                            '@_': 'id',
                                          },
                                          spaceRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                space: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'organization',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'spaceType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': [
                                  '!space_use',
                                  {
                                    ref: {
                                      entity: '!group',
                                    },
                                  },
                                ],
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  'ent:!space_use:!group',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!space:!room',
                  selection: {
                    '*': [
                      {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '+': {
                                    '@': 'weights',
                                  },
                                },
                                0,
                              ],
                            },
                            0,
                          ],
                          {
                            '/': [
                              {
                                '+': {
                                  '@': 'allowableWeights',
                                },
                              },
                              {
                                '+': {
                                  '@': 'weights',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '@.': '!sqft',
                      },
                    ],
                  },
                  subqueries: {
                    weights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'organization',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '??': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                      subqueries: {
                        room: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                          },
                          target: 'ent:!space:!room',
                        },
                        organization: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                            inherit: '=',
                          },
                          using: 'room',
                          filter: {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '@$': 'orgEntityId',
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '@$': 'orgRecordId',
                              },
                            ],
                          },
                          target: 'ent:!org_space:!entry',
                        },
                      },
                    },
                    organization: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                        inherit: '=',
                      },
                      filter: {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    roomOrgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    allowableWeights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@$': 'orgEntityId',
                                  },
                                  null,
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'organization',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'funcIdcCat',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '??': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                      subqueries: {
                        room: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                          },
                          target: 'ent:!space:!room',
                        },
                        funcIdcCat: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!func_space',
                          },
                          target: 'ent:!func_space:!func',
                          selection: {
                            '@.': [
                              '!func_idc',
                              {
                                ref: {
                                  entity: '!cat',
                                },
                              },
                            ],
                          },
                        },
                        organization: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                            inherit: '=',
                          },
                          using: 'room',
                          filter: {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '@$': 'orgEntityId',
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '@$': 'orgRecordId',
                              },
                            ],
                          },
                          target: 'ent:!org_space:!entry',
                        },
                      },
                    },
                  },
                },
                roomSqfts: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'organization',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'spaceType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': [
                                  '!space_use',
                                  {
                                    ref: {
                                      entity: '!group',
                                    },
                                  },
                                ],
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  'ent:!space_use:!group',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!space:!room',
                  selection: {
                    '@.': '!sqft',
                  },
                  subqueries: {
                    organization: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                        inherit: '=',
                      },
                      filter: {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    roomOrgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                  },
                },
                organizations: {
                  ref: {
                    attr: 'attr:ent#!org_space#!entry:!space',
                    inherit: '-',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              entity: {
                                '``': {
                                  '@$': 'orgEntityId',
                                },
                              },
                            },
                          },
                        ],
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  target: 'ent:!org_space:!entry',
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'asf',
                  direct: {
                    '{}': {
                      name: 'ASF',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'totalSqft',
                  direct: {
                    '{}': {
                      name: 'Total Area',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'utilization',
                  direct: {
                    '{}': {
                      name: 'Utilization',
                      type: 'PERCENT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'totalSqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'records',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'records',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'totalSqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'spaceRecordId',
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'organizations',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'dim::!space',
                  selection: {
                    '{}': {
                      asf: {
                        '??': [
                          {
                            '+': {
                              '@': 'space',
                            },
                          },
                          0,
                        ],
                      },
                      onClick: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'spaceEntityIdSegment',
                                  },
                                },
                                'ent:!space:!floor',
                              ],
                            },
                            null,
                          ],
                          {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          segmentId: 'space',
                                          variables: {
                                            if: [
                                              [
                                                {
                                                  and: [
                                                    {
                                                      '=': [
                                                        {
                                                          '``': {
                                                            '@$': 'piRecordId',
                                                          },
                                                        },
                                                        null,
                                                      ],
                                                    },
                                                    {
                                                      '=': [
                                                        {
                                                          '``': {
                                                            '@$': 'orgRecordId',
                                                          },
                                                        },
                                                        null,
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  '{}': {
                                                    spaceRecordId: {
                                                      '@.': '!id',
                                                    },
                                                    spaceEntityIdSegment: {
                                                      '@_': 'id',
                                                    },
                                                  },
                                                },
                                              ],
                                              [
                                                {
                                                  and: [
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '``': {
                                                              '@$': 'piRecordId',
                                                            },
                                                          },
                                                          null,
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      '=': [
                                                        {
                                                          '``': {
                                                            '@$': 'orgRecordId',
                                                          },
                                                        },
                                                        null,
                                                      ],
                                                    },
                                                  ],
                                                },
                                                {
                                                  '{}': {
                                                    piRecordId: {
                                                      '``': {
                                                        '@$': 'piRecordId',
                                                      },
                                                    },
                                                    spaceRecordId: {
                                                      '@.': '!id',
                                                    },
                                                    spaceEntityIdSegment: {
                                                      '@_': 'id',
                                                    },
                                                  },
                                                },
                                              ],
                                              [
                                                {
                                                  and: [
                                                    {
                                                      '=': [
                                                        {
                                                          '``': {
                                                            '@$': 'piRecordId',
                                                          },
                                                        },
                                                        null,
                                                      ],
                                                    },
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '``': {
                                                              '@$': 'orgRecordId',
                                                            },
                                                          },
                                                          null,
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                                {
                                                  '{}': {
                                                    orgEntityId: {
                                                      '``': {
                                                        '@$': 'orgEntityId',
                                                      },
                                                    },
                                                    orgRecordId: {
                                                      '``': {
                                                        '@$': 'orgRecordId',
                                                      },
                                                    },
                                                    spaceRecordId: {
                                                      '@.': '!id',
                                                    },
                                                    spaceEntityIdSegment: {
                                                      '@_': 'id',
                                                    },
                                                  },
                                                },
                                              ],
                                              {
                                                '{}': {
                                                  spaceRecordId: {
                                                    '@.': '!id',
                                                  },
                                                  spaceEntityIdSegment: {
                                                    '@_': 'id',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                      totalSqft: {
                        '??': [
                          {
                            '+': {
                              '@': 'roomSqfts',
                            },
                          },
                          0,
                        ],
                      },
                      utilization: {
                        '??': [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '+': {
                                        '@': 'roomSqfts',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'space',
                                    },
                                  },
                                  {
                                    '+': {
                                      '@': 'roomSqfts',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          0,
                        ],
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-link',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              spaceEntityId: {
                                                '@_': 'id',
                                              },
                                              spaceRecordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    space: {
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'organization',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '*': [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '+': {
                                        '@': 'weights',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '+': {
                                      '@': 'allowableWeights',
                                    },
                                  },
                                  {
                                    '+': {
                                      '@': 'weights',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@.': '!sqft',
                          },
                        ],
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            and: [
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgRecordId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgEntityId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '!=': [
                                      {
                                        '@': 'organization',
                                      },
                                      null,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          subqueries: {
                            room: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!space',
                              },
                              target: 'ent:!space:!room',
                            },
                            organization: {
                              ref: {
                                attr: 'attr:ent#!org_space#!entry:!space',
                                inherit: '=',
                              },
                              using: 'room',
                              filter: {
                                '=': [
                                  {
                                    '@.': [
                                      '!org',
                                      {
                                        ref: {
                                          entity: {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                ],
                              },
                              target: 'ent:!org_space:!entry',
                            },
                          },
                        },
                        organization: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                            inherit: '=',
                          },
                          filter: {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                          target: 'ent:!org_space:!entry',
                        },
                        roomOrgSpace: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                          },
                          target: 'ent:!org_space:!entry',
                        },
                        allowableWeights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            and: [
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgRecordId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '=': [
                                      {
                                        '@$': 'orgEntityId',
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    '!=': [
                                      {
                                        '@': 'organization',
                                      },
                                      null,
                                    ],
                                  },
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'funcIdcCat',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '??': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          subqueries: {
                            room: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!space',
                              },
                              target: 'ent:!space:!room',
                            },
                            funcIdcCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                            organization: {
                              ref: {
                                attr: 'attr:ent#!org_space#!entry:!space',
                                inherit: '=',
                              },
                              using: 'room',
                              filter: {
                                '=': [
                                  {
                                    '@.': [
                                      '!org',
                                      {
                                        ref: {
                                          entity: {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@$': 'orgRecordId',
                                  },
                                ],
                              },
                              target: 'ent:!org_space:!entry',
                            },
                          },
                        },
                      },
                    },
                    roomSqfts: {
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'organization',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '@.': '!sqft',
                      },
                      subqueries: {
                        organization: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                            inherit: '=',
                          },
                          filter: {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                          target: 'ent:!org_space:!entry',
                        },
                        roomOrgSpace: {
                          ref: {
                            attr: 'attr:ent#!org_space#!entry:!space',
                          },
                          target: 'ent:!org_space:!entry',
                        },
                      },
                    },
                    organizations: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!org_space:!entry',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
